import { Directive, DoCheck, ElementRef, Input, NgZone, OnDestroy } from '@angular/core';
import { fromEvent as observableFromEvent, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import { EventService } from '../../services/event.service';
import { AngularEvents } from '../../shared-context/angular-events';

// Directive to capture scroll events on the target element and broadcast using supplied event name
@Directive({
    selector: '[ohpScrollListener]'
})
export class ScrollListenerDirective implements OnDestroy, DoCheck {

    @Input('eventName') public eventName: AngularEvents;

    private initialized: boolean;
    private scrollEventSubscription: Subscription;

    constructor(
        private readonly elementRef: ElementRef,
        private readonly eventService: EventService,
        private readonly zone: NgZone
    ) {
        this.eventName = this.eventName || AngularEvents.contentScrolled;
    }

    public ngDoCheck() {
        if (!this.initialized) {
            this.initialized = true;
            this.setScrollListener();
        }
    }

    public ngOnDestroy() {
        if (this.scrollEventSubscription) {
            this.scrollEventSubscription.unsubscribe();
        }
    }

    private setScrollListener() {
        // By 'zone.runOutsideAngular()' we are opting out of change detection for the 'scroll' event.
        // We noticed that this was slowing down IE scrolling, making the experience feel choppy
        this.zone.runOutsideAngular(() => {
            this.scrollEventSubscription = observableFromEvent(this.elementRef.nativeElement, 'scroll').pipe(
                debounceTime(10))
                .subscribe(() => {
                    this.eventService.broadcastEvent({
                        name: this.eventName,
                        args: []
                    });
                });
        });
    }
}
